import { supportedLocales, type LocaleCode } from './locales';

export const localeEndonyms: Readonly<Record<LocaleCode, string>> = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  ja: '日本語',
  fr: 'Français',
};

for (const code of supportedLocales) {
  if (!localeEndonyms[code] || localeEndonyms[code].length === 0) {
    throw new Error(`Missing endonym label for locale: ${code}`);
  }
}

export function getLocaleLabel(code: LocaleCode): string {
  return localeEndonyms[code];
}
